import compile from './compile';
import AreaPlugin from 'rete-area-plugin';

import { fixDuplicatedModuleKeys } from './fixDuplicatedKeys';

const openModule = async({ name, engine, editor, currentModule, modules }) => {

    // TODO: The value is overwritten every time so no need to fo the following line
    currentModule.data = editor.toJSON();
    currentModule = modules[name];

    await editor.fromJSON(fixDuplicatedModuleKeys(currentModule.data)); // correct id of (all) nodes if you change modules

    editor.trigger('process');
    editor.view.resize();
    AreaPlugin.zoomAt(editor);

    compile({
        engine,
        editor,
    });

    return currentModule;
}

export default openModule;